import styled from 'styled-components';
import { Text } from '@playbookux/playbook-web-core';

export const Bold = styled(Text.Bold)`
  color: ${({ theme }) => theme.color.textHeaderLarge};
`;

export const Container = styled.div`
  display: flex;
  padding: 34px 34px 44px 34px;
  flex-direction: column;
  color: ${({ theme }) => theme.color.textHeaderLarge};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 14px;

  ${Bold} {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 4px;
  }
`;

export const SubHeader = styled.div`
  margin-top: 15px;
  margin-bottom: 20px;
  font-size: 14px;

  line-height: 1.3;
`;

export const Content = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 25px;
`;

export const SquareContent = styled.div`
  margin-left: 20px;
  margin-top: ${({ top }) => (top ? `${top}px` : '10px')};
  font-size: 14px;
  text-align: left;

  line-height: 1.3;

  ${({ center }) => center && 'display: flex; justify-content: center;'}
`;

export const SquareContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.color.inputBorder};
  border-radius: 5px;
  padding: 20px;

  ${Bold} {
    text-align: center;
    font-size: 16px;
    font-weight: 500;

    &.low {
      font-size: 14px;
    }
  }
`;

export const UpgradeContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;
